/**
 * orga app | admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Veranstaltung { 
    mandant_id?: string;
    modified_on_utc?: string;
    veranstaltung_id?: string;
    titel?: string;
    beginn_utc?: string;
    einlass_utc?: string;
    ist_beendet?: boolean;
    ist_veroeffentlicht?: boolean;
    ist_freigegeben?: boolean;
    saison?: string;
    saison_id?: string;
    ist_geloescht?: boolean;
    ist_reaktiviert?: boolean;
    typ_bezeichnung?: string;
    typ_id?: string;
}

